/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var MAIN = {};

  MAIN.setMenu = function()
  {
    $('#icon-menu').on('click', function(){
		  $(this).toggleClass('is-open');
      $('.brand-primary, .nav-toggle').toggleClass('is-open');
	  });
  };

  MAIN.setCover = function()
  {
    var vh = $(window).height();
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isChrome = !!window.chrome && !!window.chrome.webstore;
    var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || !isChrome && !isOpera && window.webkitAudioContext !== undefined;

    $(window).on('resize', function(){
      vh = $(window).height();
    }).trigger('resize');

    if (!feature.srcset) {
      $('body').addClass('no-srcset');
    }

    function setMinHeight() {
      var h;
      if (window.matchMedia('(max-width: 767px)').matches) {
        h = vh;
      } else if (window.matchMedia('(min-width: 768px)').matches) {
        h = '100vh';
      }
      $('.frontpage-main').css({
        'margin-top': h,
        'min-height': h
      });
    }

    function random(array, num) {
      var a = array;
      var t = [];
      var r = [];
      var l = a.length;
      var n = num < l ? num : l;
      while (n-- > 0) {
        var i = Math.random() * l | 0;
        r[n] = t[i] || a[i];
        --l;
        t[i] = t[l] || a[l];
      }
      return r;
    }

    function setFadeAway() {
      $('.cover-item').on('click', function(){
        $('html, body').animate({scrollTop: vh}, 1000, 'easeInOutQuart');
        return false;
      });
      $(window).on('scroll', function() {
        var threshold = 1;
        var st = $(this).scrollTop();
        var op = 1 - (st / (vh / threshold));
        var c = $('.cover-item, .cover-grid-primary, .cover-grid-secondary');
        c.css('opacity', op);
        c.each(function(){
          if (op < 0) {
            $(this).css('display', 'none');
          } else {
            $(this).css('display', 'block');
          }
        });
      }).trigger('scroll');
    }

    function setStickyNav() {
      $(window).on('scroll', function() {
        var st = $(this).scrollTop();
        var target = $('.frontpage-main');
        if (st >= vh) {
          target.addClass('is-stucked');
        } else {
          target.removeClass('is-stucked');
        }
      }).trigger('scroll');
    }

    function setKillFlicker() {
      if (isSafari) {
        $('body').css('perspective', '1000');
      }
    }

    $(window).on('resize', function(){
      setMinHeight();
      if (window.matchMedia('(min-width: 768px)').matches) {
        setFadeAway();
        setStickyNav();
        setKillFlicker();
      }
    }).trigger('resize');

  };

  MAIN.setCarousel = function()
  {
    $('.carousel-poster').on('init', function(event, slick, direction) {
      //console.log('init');
      $('#cover-carousel').css('visibility', 'visible');
    });

     $('.carousel-poster').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      //fade: true,
      asNavFor: '.carousel-summary'
    });

    $('.carousel-summary').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.carousel-poster',
      dots: true,
      fade: true,
      prevArrow: '<a href="#" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="12px" height="20px" viewBox="0 0 12 20" version="1.1"><g id="Cover" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="assets" transform="translate(-143.000000, -274.000000)" fill="#000000"><polygon id="chevron-left" points="155 275.1875 145.625 284 155 292.8125 153.6875 294 143 284 153.6875 274"/></g></g></svg></a>',
      nextArrow: '<a href="#" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="12px" height="20px" viewBox="0 0 12 20" version="1.1"><g id="Cover" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="assets" transform="translate(-165.000000, -274.000000)" fill="#000000"><polygon id="chevron-right" points="165 275.1875 166.3125 274 177 284 166.3125 294 165 292.8125 174.375 284"/></g></g></svg></a>'
    });
  };

  MAIN.initFeature = function()
  {
    if (!feature.svg) {
      $('img').each(function() {
        $(this).attr('src', $(this).attr('src').replace(/\.svg/gi,'.png'));
      });
    }
    if (feature.touch) {
      $('body').addClass('touch');
    }
  };

  MAIN.setSmoothScroll = function()
  {
    var opt = {
      offsetY : -36,
      duration : 500,
      easing : 'easeInOutQuart'
    };

    $('a[href*="#"]:not([href="#"])').click(function () {
      var target = $(this.hash);
      if (!target.length) { return; }
      var targetY = target.offset().top + opt.offsetY;
      $('html,body').animate({scrollTop: targetY}, opt.duration, opt.easing);
      window.history.pushState(null, null, this.hash);
      return false;
    });
  };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var SIAF = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        MAIN.initFeature();
        MAIN.setMenu();
        MAIN.setSmoothScroll();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        MAIN.setCover();
        MAIN.setCarousel();
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = SIAF;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
